import request from '@/utils/request'

//getShipNoList
export function getShipNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010klkl/getShipNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//getBlockList
export function getBlockList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010klkl/getBlockList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//getDlyNoList
export function getDlyNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010klkl/getDlyNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa012detailKl
export function epmsa012detailKl(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010klkl/epmsa012detailKl`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa013Kl
export function epmsa013Kl(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010klkl/epmsa013Kl`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010DelyNo
export function epmsa010DelyNo() {
  let data = ''
  return request({
    url: `/outsoucingBlockControl/epmsa010klkl/epmsa010DelyNo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010saveKl
export function epmsa010saveKl(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010klkl/epmsa010saveKl`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010deleteKl
export function epmsa010deleteKl(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010klkl/epmsa010deleteKl`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}


//epmsa012klxls
export function epmsa012klxls(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa010klkl/epmsa012klxls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `Steel Assy Delivery Note.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}